import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const activityLogService = {
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.module) params.set('module', filters.module);
    if (filters.action) params.set('action', filters.action);
    if (filters.email) params.set('email', filters.email);
    if (filters.limit) params.set('limit', String(filters.limit));

    const qs = params.toString();
    const url = `${API_BASE_URL}/activity-logs${qs ? `?${qs}` : ''}`;
    const res = await axios.get(url, { headers: getAuthHeaders() });
    return res.data;
  },

  activeUsers: async () => {
    const res = await axios.get(`${API_BASE_URL}/activity-logs/active-users`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },
};

export default activityLogService;
